var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useField } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { Checkbox, Grid, FormControlLabel } from '@material-ui/core';
const StyledGrid = styled(Grid) `
  display: flex;
  flex-direction: column;
`;
export const FormikCheckboxField = (_a) => {
    var { name, label, grid, color = 'primary' } = _a, checkboxProps = __rest(_a, ["name", "label", "grid", "color"]);
    const [field] = useField(name);
    return (React.createElement(StyledGrid, Object.assign({ item: true, className: 'formik-text-field' }, grid),
        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, Object.assign({ color: color }, field, { checked: field.value }, checkboxProps)), label: label })));
};
export default FormikCheckboxField;
//# sourceMappingURL=FormikCheckboxField.js.map